// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Chat_wrapper_2Z_M2","top":"Chat_top_3VarW","inner":"Chat_inner_3R4EY"};